import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=6f0596e3&scoped=true"
import script from "./DictItemList.vue?vue&type=script&lang=js"
export * from "./DictItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0596e3",
  null
  
)

export default component.exports